import { ANNOTATION_FONT } from '../../shared/geometry';
import type { Measure } from '../../shared/math';

let ctx: CanvasRenderingContext2D | null = null;

/** Formül yerleşimi için yazı genişliği; çizimde kullanılan yazı tipiyle ölçer. */
export const measureText: Measure = (text, size) => {
  ctx ??= document.createElement('canvas').getContext('2d');
  if (!ctx) return text.length * size * 0.62;
  ctx.font = `${size}px "${ANNOTATION_FONT}", sans-serif`;
  return ctx.measureText(text).width;
};
